(() => {
  if (window.pgKundenfotos) return;
  window.pgKundenfotos = true;

  let dialog;
  let opener;
  let reviews = [];
  let index = 0;

  function closeDialog() {
    if (!dialog?.hasAttribute('open')) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('pg-kf-dialog-open');
    if (opener?.isConnected) opener.focus();
  }

  function createDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'pg-kf pg-kf-dialog';
    dialog.setAttribute('data-pg-kf-dialog', '');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'PgKfDialogHeading');
    dialog.innerHTML = `
      <div class="pg-kf-dialog__top"><span data-pg-kf-counter aria-live="polite"></span>
        <button type="button" data-pg-kf-close aria-label="Großansicht schließen">×</button></div>
      <div class="pg-kf-dialog__image"><img data-pg-kf-dialog-image width="1024" height="1024" alt=""></div>
      <div class="pg-kf-dialog__text" data-pg-kf-dialog-text></div>
      <button type="button" class="pg-kf-dialog__prev" data-pg-kf-prev aria-label="Vorheriges Kundenfoto">←</button>
      <button type="button" class="pg-kf-dialog__next" data-pg-kf-next aria-label="Nächstes Kundenfoto">→</button>`;
    document.body.append(dialog);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(); });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('pg-kf-dialog-open');
      if (opener?.isConnected) opener.focus();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-pg-kf-close]')) closeDialog();
      if (event.target.closest('[data-pg-kf-prev]')) showReview(index - 1);
      if (event.target.closest('[data-pg-kf-next]')) showReview(index + 1);
    });
  }

  // Bewahrte Textformatierung, ohne ausführbares Markup oder Attribute aus Bewertungen.
  function reviewBody(html) {
    const template = document.createElement('template');
    template.innerHTML = html || '';
    const fragment = document.createDocumentFragment();
    const allowed = new Set(['p', 'br', 'b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'blockquote']);
    function append(source, target) {
      for (const child of source.childNodes) {
        if (child.nodeType === 3) target.append(document.createTextNode(child.textContent));
        else if (child.nodeType === 1 && !['script', 'style', 'iframe', 'object'].includes(child.localName)) {
          if (allowed.has(child.localName)) {
            const element = document.createElement(child.localName);
            append(child, element);
            target.append(element);
          } else append(child, target);
        }
      }
    }
    append(template.content, fragment);
    return fragment;
  }

  function showReview(next) {
    index = (next + reviews.length) % reviews.length;
    const review = reviews[index];
    const image = dialog.querySelector('[data-pg-kf-dialog-image]');
    image.src = review.image;
    image.alt = `Kundenfoto von ${review.name}`;
    const text = dialog.querySelector('[data-pg-kf-dialog-text]');
    text.replaceChildren();
    const stars = document.createElement('span');
    stars.className = 'pg-kf-stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', `${review.rating} von 5 Sternen`);
    stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
    const heading = document.createElement('h2');
    heading.id = 'PgKfDialogHeading';
    heading.textContent = review.title;
    const body = document.createElement('div');
    body.append(reviewBody(review.body));
    const author = document.createElement('p');
    author.className = 'pg-kf-author';
    author.textContent = review.name;
    if (review.verified === true) {
      const verified = document.createElement('span');
      verified.className = 'pg-kf-verified';
      verified.textContent = ' · Verifiziert';
      author.append(verified);
    }
    author.append(document.createTextNode(` · ${review.date}`));
    text.append(stars, heading, body, author);
    text.scrollTop = 0;
    dialog.querySelector('[data-pg-kf-counter]').textContent = `${index + 1} / ${reviews.length} Kundenfotos`;
    for (const button of dialog.querySelectorAll('[data-pg-kf-prev], [data-pg-kf-next]')) button.hidden = reviews.length < 2;
  }

  function selectSlide(gallery, slide) {
    for (const item of gallery.querySelectorAll('.product__media-item')) {
      const active = item === slide;
      if (item.classList.contains('is-active') !== active) item.classList.toggle('is-active', active);
    }
    for (const button of gallery.querySelectorAll('[id^="GalleryThumbnails-"] button')) button.removeAttribute('aria-current');
    const thumbnail = slide.matches('[data-pg="kf-slide"]')
      ? gallery.querySelector('[data-pg-kf-thumb]')
      : [...gallery.querySelectorAll('[data-target]')].find((item) => item.dataset.target === slide.dataset.mediaId)?.querySelector('button');
    thumbnail?.setAttribute('aria-current', 'true');
    for (const button of gallery.querySelectorAll('[data-pg-kf-single]')) {
      const customer = slide.matches('[data-pg="kf-slide"]');
      if ((button.dataset.pgKfSingle === 'customer') === customer) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    }
  }

  function initGallery(gallery) {
    if (gallery.pgKfInitialized) return;
    const slide = gallery.querySelector('[data-pg="kf-slide"]');
    if (!slide) return;
    gallery.pgKfInitialized = true;
    gallery.classList.add('pg-kf-gallery');
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    viewer.addEventListener('slideChanged', (event) => {
      if (event.detail.currentElement) selectSlide(gallery, event.detail.currentElement);
    });
    // Direkte Dawn-Aufrufe (Variantenwechsel) setzen Produktmedien aktiv, ohne Klick-Ereignis.
    const observer = new MutationObserver((mutations) => {
      const active = gallery.querySelector('[data-media-id].product__media-item.is-active');
      if (active && slide.classList.contains('is-active')) selectSlide(gallery, active);
      if (mutations.some((mutation) => mutation.type === 'childList' && mutation.target.matches('[id^="Slider-Gallery-"]'))) viewer.resetPages?.();
    });
    observer.observe(viewer, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
    gallery.pgKfObserver = observer;
    const total = viewer.querySelector('.slider-counter--total');
    if (total) total.textContent = viewer.querySelectorAll('.product__media-item').length;
    // Bei einem Produktmedium erzeugt Dawn keine Thumbnails: der Kundenfoto-Knopf übernimmt.
    if (!gallery.querySelector('[id^="GalleryThumbnails-"]')) {
      const switcher = document.createElement('div');
      switcher.className = 'pg-kf-single-nav';
      const original = document.createElement('button');
      original.type = 'button';
      original.textContent = 'Produktbild';
      original.dataset.pgKfSingle = 'product';
      original.setAttribute('aria-current', 'true');
      const customer = document.createElement('button');
      customer.type = 'button';
      customer.textContent = 'Kundenfoto';
      customer.dataset.pgKfSingle = 'customer';
      switcher.append(original, customer);
      viewer.after(switcher);
      original.addEventListener('click', () => {
        selectSlide(gallery, viewer.querySelector('[data-media-id]'));
      });
      customer.addEventListener('click', () => {
        selectSlide(gallery, slide);
      });
    }
    // Erfasst das zusätzliche Slide auch dann, wenn Dawn schon initialisiert war.
    viewer.resetPages?.();
  }

  function initRow(root) {
    if (root.pgKfInitialized) return;
    const track = root.querySelector('[data-pg-kf-track]');
    if (!track) return;
    root.pgKfInitialized = true;
    const arrows = root.querySelector('[data-pg-kf-arrows]');
    const update = () => {
      arrows.hidden = track.scrollWidth <= track.clientWidth + 1;
      arrows.querySelector('[data-pg-kf-scroll="-1"]').disabled = track.scrollLeft <= 1;
      arrows.querySelector('[data-pg-kf-scroll="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    };
    track.addEventListener('scroll', update, {passive: true});
    if (typeof ResizeObserver !== 'undefined') {
      root.pgKfObserver = new ResizeObserver(update);
      root.pgKfObserver.observe(track);
    }
    update();
  }

  function init(scope = document) {
    scope.querySelectorAll('media-gallery').forEach(initGallery);
    scope.querySelectorAll('.pg-kf-section').forEach(initRow);
  }

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-pg-kf-thumb]');
    if (thumbnail) {
      const gallery = thumbnail.closest('media-gallery');
      const slide = gallery.querySelector('[data-pg="kf-slide"]');
      selectSlide(gallery, slide);
      window.pauseAllMedia?.();
      slide.parentElement.scrollTo({left: slide.offsetLeft});
      return;
    }
    const dawn = event.target.closest('[data-target] button');
    if (dawn) dawn.closest('media-gallery')?.querySelector('[data-pg="kf-slide"]')?.classList.remove('is-active');
    const scroll = event.target.closest('[data-pg-kf-scroll]');
    if (scroll) {
      const track = scroll.closest('.pg-kf-row-wrap').querySelector('[data-pg-kf-track]');
      track.scrollBy({left: Number(scroll.dataset.pgKfScroll) * track.clientWidth, behavior: 'smooth'});
    }
    const trigger = event.target.closest('[data-pg-kf-open]');
    if (!trigger) return;
    if (trigger.getAttribute('href') === '#pg-kundenfotos' && document.getElementById('pg-kundenfotos')) return;
    const data = trigger.closest('[data-pg-kf-root]')?.querySelector('[data-pg-kf-data]');
    if (!data) return;
    reviews = JSON.parse(data.textContent);
    if (!reviews.length) return;
    event.preventDefault();
    opener = trigger;
    createDialog();
    showReview(Number(trigger.dataset.pgKfOpen));
    if (!dialog.hasAttribute('open')) {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('pg-kf-dialog-open');
    dialog.querySelector('[data-pg-kf-close]').focus();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (!dialog?.hasAttribute('open')) return;
    if (event.key === 'Escape') { event.preventDefault(); closeDialog(); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); showReview(index - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); showReview(index + 1); }
    if (event.key === 'Tab') {
      const controls = [...dialog.querySelectorAll('button')].filter((button) => !button.hidden);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('media-gallery, .pg-kf-section').forEach((root) => {
      root.pgKfObserver?.disconnect();
      root.pgKfInitialized = false;
    });
    if (opener && event.target.contains(opener)) closeDialog();
  });
  init();
})();
